import api from '@lib/api'
import { useQuery } from '@tanstack/react-query'
import { Trip } from '@types'

export const useTrip = (tripId: string | undefined) => {
	return useQuery<Trip>({
		queryKey: ['trip', tripId],
		queryFn: async () => {
			if (!tripId) {
				throw new Error('Trip ID is required')
			}
			const response = await api.get<Trip>(`/trips/${tripId}`)
			return response.data
		},
		enabled: !!tripId, // Only run query if tripId is provided
		retry: 1,
	})
}
